export default {
	name: "assign-salesReps-to-customer-modal",
	props: ["heading", "modalId", "showModal", "companyId", "companySalesReps"],
	emits: ["onSaveClick", "onModalCloseClick"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			searchQuery: null,
			saleReps: [],
			linkedSalesReps: [],
			unlinkedSalesReps: [],
			salesRepsHeadings: [
				{
					text: "Sales Rep",
					field: "salesRep"
				},
				{
					text: "Email Address",
					field: "salesRepEmail"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loading: false
		};
	},
	methods: {
		getCompanySalesReps(){
			console.log("companyId", this.companyId);
			let request = {
				companyId: this.companyId === null || this.companyId === "" ? 0 : this.companyId,
				searchQuery: this.searchQuery
			};
			securityService.getCompanySalesReps(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						// this.customer.companyDetails.salesRepId.value = successResponse.data.result.userId;
						// this.customer.companyDetails.salesRepName.value = successResponse.data.result.salesRep;
						this.saleReps = successResponse.data.result;
						for(let i = 0; i < this.saleReps.length; i++){
							let saleRep = this.saleReps[i];
							let item = this.linkedSalesReps.find(salesRepItem => salesRepItem.userId === saleRep.userId);
							if(item !== null && item !== undefined){
								this.saleReps[i].isAssigned = true;
							}
							else{
								if(this.unlinkedSalesReps.some(salesRepItem => salesRepItem.userId === saleRep.userId)) {
									this.saleReps[i].isAssigned = false;
								}
							}
						}
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getCompanySalesReps();
		},
		onSalesRepCheckOrUnchecked(userId){
			var salesRep = this.saleReps.find(salesRepItem => salesRepItem.userId === userId);
			console.log("salesRep", salesRep);
			if(salesRep === null || salesRep === undefined){
				return;
			}
			salesRep.isAssigned = !salesRep.isAssigned;
			
			if(salesRep.isAssigned && !this.linkedSalesReps.some(salesRepItem => salesRepItem.userId === salesRep.userId)){
				this.unlinkedSalesReps = this.unlinkedSalesReps.filter(salesRepItem => salesRepItem.userId !== salesRep.userId);
				this.linkedSalesReps.push(salesRep);
				console.log("linkedSalesReps", this.linkedSalesReps);
			}
			else{
				this.linkedSalesReps = this.linkedSalesReps.filter(salesRepItem => salesRepItem.userId !== salesRep.userId);
				var isInUnlinked = this.unlinkedSalesReps.some(salesRepItem => salesRepItem.userId === salesRep.userId);
				if(!isInUnlinked){
					this.unlinkedSalesReps.push(salesRep);
					console.log("unlinkedSalesReps", this.unlinkedSalesReps);
				}
			}

			console.log("saleReps", this.saleReps);
		},
		onSaveClick(){
			this.searchQuery = null;
			var selectedAndUnselectedSalesReps = {
				selectedSalesReps: this.linkedSalesReps,
				unselectedSalesReps: this.unlinkedSalesReps
			};
			this.$emit("onSaveClick", selectedAndUnselectedSalesReps);
		},
		onModalCloseClick(){
			this.searchQuery = null;
			this.$emit("onModalCloseClick");
		}
	},
	mounted: function () {
		
	},
	watch:{
		companyId:{
			handler: function (){
				//this.getCompanySalesReps();
			},
			immediate: true,
			deep: true
		},
		companySalesReps: {
			handler: function (){
				this.saleReps = this.companySalesReps;
				if(this.saleReps !== null && this.saleReps !== undefined) {
					this.linkedSalesReps = [];
					this.unlinkedSalesReps = [];
					for (let i = 0; i < this.saleReps.length; i++) {
						if (this.saleReps[i].isAssigned) {
							this.linkedSalesReps.push(this.saleReps[i]);
						} else {
							this.unlinkedSalesReps.push(this.saleReps[i]);
						}
					}
				}
			},
			immediate: true,
			deep: true
		},
		// salesRepsLinkedToCompany:{
		// 	handler: function (){
		// 		console.log("salesRepsLinkedToCompany", this.salesRepsLinkedToCompany)
		// 		if(this.saleReps.length === 0) {
		// 			this.saleReps.push(...this.salesRepsLinkedToCompany);
		// 		}
		// 		else{
		// 			for(let i = 0; i < this.salesRepsLinkedToCompany.length; i++) {
		// 				let saleRep = this.salesRepsLinkedToCompany[i];
		// 				let item = this.saleReps.find(salesRepItem => salesRepItem.userId === saleRep.userId);
		// 				if(item !== null && item !== undefined){
		// 					this.salesRepsLinkedToCompany[i].isAssigned = true;
		// 				}
		// 				//this.salesRepsLinkedToCompany[i].isAssigned = item !== null && item !== undefined;
		// 			}
		// 		}
		// 		this.linkedSalesReps = this.salesRepsLinkedToCompany;
		// 		console.log("salesRep", this.salesReps);
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		// salesRepsUnlinkedToCompany:{
		// 	handler: function (){
		// 		console.log("salesRepsUnlinkedToCompany", this.salesRepsUnlinkedToCompany)
		// 		if(this.saleReps.length === 0) {
		// 			this.saleReps.push(...this.salesRepsUnlinkedToCompany);
		// 		}
		// 		else{
		// 			for(let i = 0; i < this.salesRepsUnlinkedToCompany.length; i++) {
		// 				let saleRep = this.salesRepsUnlinkedToCompany[i];
		// 				let item = this.saleReps.find(salesRepItem => salesRepItem.userId === saleRep.userId);
		// 				if (item !== null && item !== undefined) {
		// 					this.salesRepsUnlinkedToCompany[i].isAssigned = false;
		// 				}
		// 			}
		// 		}
		// 		//this.saleReps.push(...this.salesRepsUnlinkedToCompany);
		// 		this.unlinkedSalesReps = this.salesRepsUnlinkedToCompany;
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					this.getCompanySalesReps();
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};